import React, { useEffect, useState } from 'react';
import Button from "../components/button/Button";
import apiClient from "../common/apiClient"
import Config from "../common/Config";
import SecondaryButton from "../components/button/SecondaryButton";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import ClearOrder from "../components/modal/ClearOrder";
import FormTitle from "../components/formTitle/FormTitle";
import { ClipLoader } from "react-spinners";

import {
    FormGroup,
    FormLabel,
} from "@mui/material";

const MultiProductController = (props) => {
    const [formData, setFormData] = useState([]);
    const [formTypeIdsToAdd, setFormTypeIdsToAdd] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [addingProduct, setAddingProduct] = useState(false);


    const footFormTypeId = 15

    async function addProduct(id) {
        setAddingProduct(true)
        try {
            const formTypeIdsToAdd = await props.productsAdded()
            if (formTypeIdsToAdd.includes(id.toString())) {
                return null;
            }
            let addedFormTypeIDs = formTypeIdsToAdd.split(",").filter(id => id !== '')
            addedFormTypeIDs.push(id)

            await saveIds(addedFormTypeIDs)
            props.setFormTypeIdsToAdd(addedFormTypeIDs)
            await props.addFormData(addedFormTypeIDs)
        } catch (ex) {
            console.log(ex)
        }
    }

    function productAdded(id) {
        if (!formTypeIdsToAdd) {
            return false
        }
        return formTypeIdsToAdd.includes(id.toString())
    }

    async function saveIds(addedFormTypeIDs) {

        addedFormTypeIDs = addedFormTypeIDs.filter(p => p !== "");
        const formTypeIdsToAddJson = addedFormTypeIDs.toString();

        let data = [];
        data.push({
            fieldName: "addedFormTypeIDs",
            stringData: formTypeIdsToAddJson,
        });

        return await apiClient.post(
            `fieldInputs/${props.formTypeId}?isMulti=${true}&parentFormTypeId=${props.parentFormTypeId}`,
            data
        )
    }

    async function removeProduct(fd) {
        let idToRemove = fd.formContent.props.formTypeId
        let addedFormTypeIDs = props.formTypeIdsToAdd
        addedFormTypeIDs = addedFormTypeIDs.filter(i => parseInt(i) !== idToRemove)
        props.setFormTypeIdsToAdd(addedFormTypeIDs)
        await props.removeProduct(fd)
        await saveIds(addedFormTypeIDs)
        await props.handleBack()
    }

    function makeLoadingText() {
        return (
            <div className="loader">
                <ClipLoader color="#000000" size={40} />
            </div>
        );
    }

    useEffect(() => {
        const loadData = async () => {
            const formData = await props.getFormData()
            await setFormData(formData)

            const addedFormTypeIDs = await props.productsAdded()
            await setFormTypeIdsToAdd(addedFormTypeIDs)

            setIsLoaded(true)
        }
        loadData()
    }, [])

    if (!isLoaded) return makeLoadingText();
    return (
            <>
                <div className="checkFormWrapper filedWidth">
                    <FormTitle
                        title="Add Product"
                        description=""
                    />

                    <form className="checkform" onSubmit={e => { e.preventDefault() }}>
                        <div className="fieldBorder">
                            <h4 className="headLable">Products to Add</h4>
                            <div className="stepBtn">
                                <SecondaryButton
                                    text="Add Feet"
                                    onClick={() => addProduct(footFormTypeId)}
                                    disabled={productAdded(footFormTypeId) || addingProduct}
                                />
                            </div>
                        </div>

                        <div className="muiCheckbox d-none">
                            <FormLabel id="demo-radio-buttons-group-label"><div className="font-weight-bolder">Additional Products in Order</div></FormLabel>
                            <FormGroup row>
                                {productAdded(footFormTypeId) ?
                                    (
                                        formData
                                            .filter(fd => fd.id !== 4 && (fd.name === "Liners" || fd.name === "Feet"))
                                            .map((fd, index) => (
                                                <div key={index} className="stepBtn">
                                                    <SecondaryButton
                                                        text={`Remove ${fd.name}`}
                                                        onClick={async () => {
                                                            await removeProduct(fd);
                                                        }}
                                                    />
                                                </div>
                                            ))
                                    )
                                    : <>None</>}
                            </FormGroup>
                        </div>

                    </form>

                </div>

                <div className="handelButtons">
                    <SecondaryButton
                        text="Save As Draft"
                        onClick={props.handleClickOpen}
                    />
                    <SecondaryButton
                        text="Clear the Order?"
                        onClick={props.handleClickClearOpen}
                    />
                    <div className="stepBtn">
                        <SecondaryButton
                            text="Back"
                            onClick={() => props.handleBack()}
                        />
                        <Button
                            text="Next"
                            onClick={() => props.handleNext()}
                        />
                    </div>
                </div>
                <SaveAsDraft
                    open={props?.open == null ? false : props?.open}
                    handleClose={props.handleClose}
                    showSubmit={props.showSubmit}
                    setShowSubmit={props.setShowSubmit}
                />
                <ClearOrder
                    openClear={props.openClear}
                    handleCloseClear={props.handleCloseClear}
                    showClear={props.showClear}
                    setShowClear={props.setShowClear}
                    formId={props.formTypeId}
                    handleClearBack={props.handleClearBack}
                />

            </>
    )
}

export default MultiProductController
